// Turns an axios rejection into something worth showing a user.
//
// Without this every failure surfaces as "Request failed with status code 400",
// because that is what axios puts in err.message - the server's actual
// complaint sits unread in err.response.data.

const NETWORK =
    "Could not reach the server. Check your internet connection and try again.";

// DRF nests errors arbitrarily: {"email": ["Enter a valid email."]} for a flat
// serializer, {"members": [{}, {"cnic": ["..."]}]} for a nested one. Walk it
// and keep the leaf strings, labelled by the field they came from.
const collect = (value, field, out) => {
    if (out.length >= 3) return;

    if (typeof value === "string") {
        // non_field_errors and detail are not real field names - no label
        const label =
            !field || field === "non_field_errors" || field === "detail"
                ? ""
                : `${field.replace(/_/g, " ")}: `;
        out.push(label + value);
    } else if (Array.isArray(value)) {
        value.forEach((item) => collect(item, field, out));
    } else if (value && typeof value === "object") {
        Object.entries(value).forEach(([key, item]) => collect(item, key, out));
    }
};

const errorMessage = (err) => {
    // No response at all: offline, DNS failure, CORS rejection, timeout.
    if (!err?.response) return NETWORK;

    const { status, data } = err.response;

    if (typeof data === "string" && data.trim() && !data.includes("<html")) {
        return data.trim();
    }

    if (data && typeof data === "object") {
        if (typeof data.message === "string") return data.message;

        const messages = [];
        collect(data, "", messages);
        if (messages.length) return messages.join(" ");
    }

    // A response with nothing usable in it - status is better than nothing.
    if (status >= 500) return "The server hit an error. Please try again shortly.";
    if (status === 404) return "That endpoint was not found.";
    return err.message || "Something went wrong.";
};

export default errorMessage;
